var exports = {
  "k": "xfd349460--827a93--container",
};

module.exports = exports;
